var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomPanelClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#727A82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.947 2.994 C 3.559 3.129,3.249 3.408,3.058 3.796 L 2.950 4.015 2.950 10.000 L 2.950 15.985 3.064 16.217 C 3.214 16.521,3.479 16.786,3.783 16.936 L 4.015 17.050 10.000 17.050 L 15.985 17.050 16.217 16.936 C 16.521 16.786,16.786 16.521,16.936 16.217 L 17.050 15.985 17.050 10.000 L 17.050 4.015 16.936 3.783 C 16.786 3.479,16.521 3.214,16.217 3.064 L 15.985 2.950 10.051 2.943 C 4.456 2.936,4.107 2.938,3.947 2.994 M15.752 4.248 L 15.833 4.330 15.833 8.215 L 15.833 12.100 10.000 12.100 L 4.167 12.100 4.167 8.215 L 4.167 4.330 4.248 4.248 L 4.330 4.167 10.000 4.167 L 15.670 4.167 15.752 4.248 M8.508 8.125 L 10.000 9.617 11.492 8.125 L 12.983 6.633 10.000 6.633 L 7.017 6.633 8.508 8.125 M15.833 14.502 L 15.833 15.670 15.752 15.752 L 15.670 15.833 10.000 15.833 L 4.330 15.833 4.248 15.752 L 4.167 15.670 4.167 14.502 L 4.167 13.333 10.000 13.333 L 15.833 13.333 15.833 14.502 ",
    stroke: "none",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomPanelClose);
export default __webpack_public_path__ + "static/media/bottom-panel-close.5baeb8a90f2ac25ebbc0aee9bda7bc3d.svg";
export { ForwardRef as ReactComponent };